// src/components/settings/RowActionMenu.jsx
import React from "react";

const RowActionMenu = ({
  user,
  openMenuId,
  actionMenuRefs,
  toggleRowActions,
  handleEditUser,
  handleDeleteUser,
  setOpenMenuId,
}) => {
  // Determine if this specific menu is currently open
  const isMenuOpen = openMenuId === user.id;

  return (
    // Apply 'is-menu-active' class to the td if this menu is open
    <td className={`table-actions-cell ${isMenuOpen ? "is-menu-active" : ""}`}>
      <div className="row-actions-wrapper">
        <button
          className="ellipsis-button"
          onClick={(e) => toggleRowActions(user.id, e)}
          // Add data-user-id for the handleClickOutside improvement
          data-user-id={user.id}
        >
          {/*&#8230;*/}
          &#x22EE; {/* Vertical Ellipsis character */}
        </button>
        {isMenuOpen && ( // Use isMenuOpen for rendering the menu
          <div
            className="row-action-menu is-open"
            ref={(el) => (actionMenuRefs.current[user.id] = el)}
          >
            <button
              onClick={() => {
                handleEditUser(user);
                setOpenMenuId(null);
              }}
              className="action-menu-item"
            >
              Edit
            </button>
            <button
              onClick={() => {
                handleDeleteUser(user.id);
                setOpenMenuId(null);
              }}
              className="action-menu-item delete-item"
            >
              Delete
            </button>
          </div>
        )}
      </div>
    </td>
  );
};

export default RowActionMenu;
